// extracted by mini-css-extract-plugin
export default {"textBlock":"NewProject_textBlock__Y6LmA","title":"NewProject_title__7sGUL","desc":"NewProject_desc__b1c6u","projectList":"NewProject_projectList__t2R+T"};